import { Injectable } from '@angular/core';
import { BaseAccessService } from '@zaoblako/web/core/models/enums/access-rules/base-access.service';
import { ManualAccessRulesKeyEnum } from './manual-access-rules-key.enum';
import { ManualAccessRulesConst } from './manual-access-rules.const';

@Injectable({
  providedIn: 'root'
})
export class ManualAccessService extends BaseAccessService<ManualAccessRulesKeyEnum> {
  public constructor() {
    super(ManualAccessRulesConst);
  }

  public get manualRights() {
    return {
      canWriteManual: this.globalService.isAccessRule(
        ManualAccessRulesConst[ManualAccessRulesKeyEnum.FROM_AI_MANUAL_WRITE]
      ),
      canWriteAiChat: this.globalService.isAccessRule(
        ManualAccessRulesConst[ManualAccessRulesKeyEnum.FROM_AI_CHAT_WRITE]
      )
    };
  }
}
